import { ISOStringToDate, isValidDateObject } from '../../helpers/time';
import { DateTimeFormatters } from '@showclix-shared-intl';
import { getSeparatedEventDate, getEventDate } from './helpers';

export const getTitle = (name, uiConfig) => {
    let title = name;
    if (uiConfig?.listings && uiConfig?.listings?.useEventTitle !== 'undefined' &&
        uiConfig?.listings?.useEventTitle === false) {
        title = uiConfig?.listings?.title;
    }
    return title;
};

export const getIsHideEventDateAndTime = (uiConfig) => uiConfig?.hide_event_date_and_time;

export const getIsHideEventTime = (uiConfig) => uiConfig?.hide_event_time;

export const isCustomTimeUsed = (uiConfig) =>
    uiConfig?.listings.useEventTime !== 'undefined' &&
    uiConfig?.listings.useEventTime === false;

export const getTime = (uiConfig, isRecurring, start, end, locale) => {
    if (uiConfig?.listings && isCustomTimeUsed(uiConfig)) {
        return uiConfig?.listings?.time;
    }

    if (isRecurring) {
        if (uiConfig?.hide_event_date_and_time){
            return null;
        }
        let startDate = ISOStringToDate(start);
        if (!isValidDateObject(startDate)) {
            return null;
        }

        let endDate = null;
        if(end) {
            endDate = ISOStringToDate(end);
        }

        const {monthDayShort, monthDayYearShort} = DateTimeFormatters;

        if (!isValidDateObject(endDate)) {
            return monthDayShort(locale, startDate);
        }

        let startingYear = startDate.getFullYear();
        let endingYear = endDate.getFullYear();
        if(startingYear == endingYear){
            return `${monthDayShort(locale, startDate)} - ${monthDayYearShort(locale, endDate)}`;
        } else {
            return `${monthDayYearShort(locale, startDate)} - ${monthDayYearShort(locale, endDate)}`;
        }
    }
    return getEventDate(start, end, locale, getIsHideEventTime(uiConfig), getIsHideEventDateAndTime(uiConfig));
};

export const getTimezone = (uiConfig, timezone) => {
    if(isCustomTimeUsed(uiConfig) || getIsHideEventTime(uiConfig) || getIsHideEventDateAndTime(uiConfig)) {
        return null;
    }

    return timezone;
}

export const getLocation = (uiConfig, venueName, venueAddress) => {
    if (uiConfig?.hide_venue){
        return null;
    }

    let location = venueName + ", " + venueAddress;
    if(uiConfig?.listings && uiConfig?.listings?.useEventLocation !== 'undefined' &&
        uiConfig?.listings?.useEventLocation === false) {
        location = uiConfig?.listings?.location;
    }

    return location;
};

export const getAltText = (name, uiConfig) => {
    const altText = uiConfig?.images?.headerAltText;
    return altText || getTitle(name, uiConfig);
};

export const getSeparatedDate = (uiConfig, isRecurring, start, end, locale) => {
    const empty = {
        date: '',
        time: '',
    };

    if (uiConfig?.listings && isCustomTimeUsed(uiConfig)) {
        return {
            date: uiConfig?.listings.time
        };
    }

    if (isRecurring) {
        if (uiConfig?.hide_event_date_and_time){
            return empty;
        }
        let startDate = ISOStringToDate(start);
        if (!isValidDateObject(startDate)) {
            return empty;
        }

        let endDate = null;
        if(end) {
            endDate = ISOStringToDate(end);
        }

        const {monthDayShort, monthDayYearShort} = DateTimeFormatters;

        if (!isValidDateObject(endDate)) {
            return {
                date: monthDayShort(locale, startDate),
            }
        }

        let startingYear = startDate.getFullYear();
        let endingYear = endDate.getFullYear();
        if(startingYear == endingYear){
            return {
                date: `${monthDayShort(locale, startDate)} - ${monthDayYearShort(locale, endDate)}`,
            };
        } else {
            return {
                date: `${monthDayYearShort(locale, startDate)} - ${monthDayYearShort(locale, endDate)}`,
            };
        }
    }

    return getSeparatedEventDate({
        eventStart: start,
        eventEnd: end,
        locale: locale,
        hide_time: getIsHideEventTime(uiConfig),
        hide_date_time: getIsHideEventDateAndTime(uiConfig),
    });
}

export const getSeparatedLocation = (uiConfig, venueName, venueAddress) => {
    if (uiConfig?.hide_venue){
        return {
            venueName: '',
            venueAddress: '',
        }
    }

    if (uiConfig?.useEventLocation !== 'undefined' && !uiConfig?.listings?.useEventLocation) {
        return {
            venueName: uiConfig?.listings?.location,
        }
    }

    return {
        venueName,
        venueAddress,
    }
}
